import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { DummyStorage } from './dummy-storage';
import * as i0 from "@angular/core";
/**
 * NOTE: Inject BrowserLocalStorage to access localStorage.
 * In browser, original window.localStorage will be injected instead of BrowserLocalStorage,
 * which is a dummy storage implementation used in SSR env.
 */
export let BrowserLocalStorage = /*#__PURE__*/(() => {
  class BrowserLocalStorage extends DummyStorage {
    constructor() {
      super();
    }
    static {
      this.ɵfac = function BrowserLocalStorage_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BrowserLocalStorage)();
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: BrowserLocalStorage,
        factory: BrowserLocalStorage.ɵfac
      });
    }
  }
  return BrowserLocalStorage;
})();
export const localStorageProvider = {
  provide: BrowserLocalStorage,
  useFactory: platformId => {
    if (isPlatformServer(platformId)) return new BrowserLocalStorage();
    return window.localStorage;
  },
  deps: [PLATFORM_ID]
};